<template>
  <div class="blacklist">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead /></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">关键词</div>
            <el-input
              size="small" placeholder="姓名/身份证/手机号"
              v-model="listQuery.keyword"
              @keyup.enter.native="searchHandle"
            ></el-input>
          </div>
          <div class="screenInput">
            <el-button type="success" size="small" @click="searchHandle">搜索</el-button>
          </div>
          <!-- <div class="screenInput">
            <div class="flname">身份证号</div>
            <el-input
              size="small"
              v-model="listQuery.idcard"
              @keyup.enter.native="getBlackList()"
            ></el-input>
          </div> -->
        </div>
      </div>
      <!-- <div class="top-right">
        <el-button
          type="text"
          @click="dropDownScreen"
          style="margin-right: 24px"
        >
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div> -->

      <!-- 筛选下拉框 -->
      <!-- <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select
              v-model="listQuery.strsrvcent"
              placeholder=""
              filterable
            >
              <el-option
                v-for="(item, index) in serviceList"
                :key="index"
                :label="item.StrSrvCent"
                :value="item.StrSrvCent"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>业务立项部门</div>
            <el-select
              v-model="listQuery.strobjinstname"
              placeholder=""
              filterable
            >
              <el-option
                v-for="(item, index) in apartmentList"
                :key="index"
                :label="item.StrObjInstName"
                :value="item.StrObjInstName"
              ></el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>项目名称</div>
            <el-input
              size="small"
              v-model="listQuery.strobjname"
              placeholder=""
            ></el-input>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="resetHandle">
            清空
          </button>
          <button class="search" @click="getBlackList">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div> -->
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>黑名单</el-breadcrumb-item>
          <el-breadcrumb-item>黑名单列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="blacklistTable">
        <div class="btnBox">
          <el-button type="primary" size="small" v-if="checkPermission(['empBlacklist_add'],permissionLists)" @click="addHandle">新增黑名单</el-button>
        </div>
        <!-- :header-cell-style="{background:'#f2f2f2',color: '#909399'}" -->
        <el-table ref="blackTable" class="com_table" border v-loading="listLoading" 
        :highlight-current-row="true" :max-height="tableHeight-100" 
        :data="tableData" style="width:100%"
        >
          <!-- <el-table-column type="selection" width="40"></el-table-column> -->
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.currpage - 1) * Number(listQuery.perpage)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column label="姓名" fixed="left" fit :show-overflow-tooltip="true" min-width="110px" align="center">
            <template slot-scope="{row}">
              <span>{{row.StrUserName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" fit :show-overflow-tooltip="true" min-width="110px" align="center">
            <template slot-scope="{row}">
              <span>{{row.StrMobile}}</span>
            </template>
          </el-table-column>
          <el-table-column label="身份证" fit :show-overflow-tooltip="true" min-width="130px" align="center">
            <template slot-scope="{row}">
              <span>{{row.StrIdCard}}</span>
            </template>
          </el-table-column>
          <el-table-column label="黑名单原因" fit :show-overflow-tooltip="true" min-width="110px" align="center">
            <template slot-scope="{row}">
              <span>{{row.StrBlackReason}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" fit :show-overflow-tooltip="true" min-width="130px" align="center">
            <template slot-scope="{row}">
              <span>{{row.StrRemark}}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建人" fit :show-overflow-tooltip="true" min-width="130px" align="center">
            <template slot-scope="{row}">
              <span>{{row.Username}}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" fit :show-overflow-tooltip="true" min-width="110px" align="center">
            <template slot-scope="{row}">
              <span>{{row.DtInsertDate?row.DtInsertDate.replace('T',' '):''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="170px" align="center">
            <template slot-scope="{row}">
              <el-button type="primary" v-if="checkPermission(['empBlacklist_edit'],permissionLists)" plain size="mini" @click="editHandle(row)">编辑</el-button>
              <el-button type="primary" v-if="checkPermission(['empBlacklist_dlt'],permissionLists)" plain size="mini" @click="dltHandle(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page.sync="listQuery.currpage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.perpage"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :title="isEdit == true?'编辑信息':'新增信息'" :visible.sync="dialogVisible" class="black_dialog_box" width="660px">
      <div class="dialog_box">
        <el-form :inline="true" :rules="editRules" ref="blackForm" :model="updateQuery" class="dia_black_box" label-width="100px">
          <el-form-item label="姓名:" prop="StrUserName">
            <el-input v-model.trim="updateQuery.StrUserName" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="StrMobile">
            <el-input v-model.trim="updateQuery.StrMobile" size="small" oninput="value=value.replace(/^\.+|[^\d.]/g,'')" clearable></el-input>
          </el-form-item>
          <el-form-item label="身份证:" prop="StrIdCard">
            <el-input v-model.trim="updateQuery.StrIdCard" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="黑名单原因:" prop="other">
            <div class="flex_form_box">
              <el-select v-model="updateQuery.other" @change="reasonHandle" placeholder="" size="small" clearable>
                <el-option v-for="item in blackLabelList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
                <el-option value="其他">其他</el-option>
              </el-select>
              <!-- <el-input v-model="updateQuery.remark" type="textarea" rows="2" size="small" clearable></el-input> -->
            </div>
          </el-form-item>
          <el-form-item prop="StrBlackReason" label="原因" class="input_width" v-if="updateQuery.other == '其他'">
            <el-input v-model="updateQuery.StrBlackReason" placeholder="请输入黑名单原因" type="textarea" rows="2" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item prop="StrRemark" label="备注" class="input_width">
            <el-input v-model="updateQuery.StrRemark" placeholder="请输入备注" type="textarea" rows="2" size="small" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="dialogVisible = false">取消</button>
        <button class="search ml20" @click="saveHandle">
          确定
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import checkPermission from '@/utils/permission' // 权限判断函数
export default {
  name: "blacklist",
  data() {
    var validatecard = (rule, value, callback) => {
        // console.log('value',value)
        if (!this.isNull(value)) {
          if (value.length != 18) {
            callback(new Error('身份证号码格式不正确'));
          } else {
            let idcode = value;
            let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, ];
            let check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
            let code = idcode + "";
            let last = idcode[17].toUpperCase(); //最后一个
            let seventeen = code.substring(0, 17);
            // ISO 7064:1983.MOD 11-2
            // 判断最后一位校验码是否正确
            let arr = seventeen.split("");
            let len = arr.length;
            let num = 0;
            for (let i = 0; i < len; i++) {
              num = num + arr[i] * weight_factor[i];
            }
            // 获取余数
            var resisue = num % 11;
            var last_no = check_code[resisue];
            // 格式的正则
            // 正则思路
            var idcard_patter = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
            // 判断格式是否正确
            var format = idcard_patter.test(idcode);
            if (last === last_no && format == true) {
              callback()
            } else {
              callback(new Error('身份证号码格式不正确'));
            }
          }
        } else {
          callback()
        }
      };
    return {
      tableHeight: 0,
      listQuery:{
        currpage: 1,
        perpage:10,
        custname: "",
        keyword:''
      },
      // 按钮权限参数
      butQuery:{
        path:'/empBlacklist',
        powerEnName:'employee'
      },
      permissionLists:[],
      // 修改信息参数
      updateQuery:{
        BlackId: "",
        StrMobile:'',// 手机
        StrUserName:'',// 姓名
        StrIdCard:'',// 身份证
        StrIsBlack:'是',// 是
        StrBlackReason:'',// 原因
        other:'',
        StrRemark:''// 备注
      },
      // 黑名单列表
      blackLabelList:[],
      listLoading: false,
      //下拉服务中心列表
      serviceList: [],
      //下拉业务立项部门
      apartmentList: [],
      dialogVisible: false,
      totalcount: 0,
      //下拉筛选
      showDropScreen: -1,
      tableData: [],
      // 规则
      editRules: {
        // StrUserName: [{
        //   required: true,
        //   message: '请输入姓名',
        //   trigger: 'blur'
        // }],
        StrIdCard: [{
          message: '请输入正确的身份证号码',
          validator: validatecard,
          trigger: ['blur']
        }],
        StrBlackReason: [{
            required: true,
            message: '请选择黑名单原因',
            trigger: ['blur']
          }
        ],
        other: [{
            required: true,
            message: '请输入黑名单原因',
            trigger: ['blur']
          }
        ]
      },
      //表头内容
      tableTitle: [],
      //角色类型
      roleType: "",
      isEdit:false
    };
  },
  created() {
    this.roleType = localStorage.loginRoletype;
    this.calHeight();
    this.getBlackList();
    this.getButtonPower();
    // this.getApartmentList();
  },
  mounted() {},
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
          }else{
            this.permissionLists = []
          }
        }else{
          this.permissionLists = []
        }
      })
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      // console.log('height',this.tableHeight)
    },
    // 删除
    dltHandle(item){
      let query = {
        BlackId: item.BlackId,
        StrMobile: item.StrMobile,
        StrUserName: item.StrUserName,
        StrIdCard: item.StrIdCard,
        StrIsBlack: item.StrIsBlack,
        StrBlackReason: item.StrBlackReason,
        StrRemark: item.StrRemark,
        StrIsDel:1
      }
      let that = this
      this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        xz.bdelJbblack(query).then(res => {
          // console.log('gettemplatelist', res)
          if (res.status == 'ok') {
            that.$message({
              type: 'success',
              message: '删除成功'
            })
            that.dialogVisible = false
            that.getBlackList();
          } else {
            that.$message({
              type: 'error',
              message: '删除失败'
            })
          }
        })
      })
    },
    // 新增黑名单
    addHandle(){
      this.updateQuery = {
        BlackId: '',
        StrMobile:'',// 手机
        StrUserName:'',// 姓名
        StrIdCard:'',// 身份证
        StrIsBlack:'是',// 是
        StrBlackReason:'',// 原因
        StrRemark:''// 备注
      }
      this.getdictdatalistbyid('132');
      this.dialogVisible = true
      this.isEdit = false
    },
    // 编辑
    editHandle(item){
      this.dialogVisible = true
      this.isEdit = true
      this.updateQuery = {
        BlackId: item.BlackId,
        StrMobile: item.StrMobile,
        StrIdCard: item.StrIdCard,
        StrUserName: item.StrUserName,
        StrIsBlack:item.StrIsBlack,
        StrBlackReason:item.StrBlackReason,
        other:'',
        StrRemark:item.StrRemark
      }
      this.getdictdatalistbyid('132');
    },
    // 选择黑名单原因
    reasonHandle(val){
      if(!this.isNull(val)){
        if(val != '其他'){
          this.updateQuery.StrBlackReason = this.updateQuery.other
        }else{
          this.updateQuery.StrBlackReason = ''
        }
      }else{
        this.updateQuery.other = ''
      }
    },
    // 确定保存
    saveHandle(){
      let that = this
      if(that.isNull(that.updateQuery.StrMobile)&&that.isNull(that.updateQuery.StrUserName)&&that.isNull(that.updateQuery.StrIdCard)){
        this.$message({
          type: 'warning',
          message: '请输入姓名/手机号/身份证其中一个'
        })
        return
      }
      if(!that.isNull(that.updateQuery.StrMobile)){
        if(that.updateQuery.StrMobile.length != 11){
          this.$message({
            type: 'warning',
            message: '请输入正确的手机号'
          })
          return
        }
      }
      this.$refs['blackForm'].validate((valid) => {
        if (valid) {
          // console.log('ss', this.updateQuery)
          xz.bsaveJbblack(this.updateQuery).then(res => {
            // console.log('gettemplatelist', res)
            if (res.status == 'ok') {
              this.$message({
                type: 'success',
                message: '操作成功'
              })
              this.dialogVisible = false
              this.getBlackList();
            } else {
              this.$message({
                type: 'error',
                message: '操作失败'
              })
            }
          })
        }
      })
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      );
    },
    //清空
    resetHandle() {
      this.listQuery.keyword = "";
      this.listQuery.currpage = 1;
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1;
      this.getBlackList();
    },
    handleCurrentChange(val) {
      this.listQuery.currpage = Number(val);
      this.getBlackList();
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.listQuery.currpage = 1;
      this.listQuery.perpage = Number(val);
      this.getBlackList();
    },
    //基本信息列表（班次、坐班站班）
    getdictdatalistbyid(id) {
      let that = this
      xz.getdictdatalistbyid(id).then(res => {
        if (res.status == 'ok') {
          if(id == '132'){ // 黑名单标签
            that.blackLabelList = res.data.retList
            if(!that.isNull(that.updateQuery.StrBlackReason)){
              if (that.blackLabelList.some(obj => obj.Name === that.updateQuery.StrBlackReason)) {
                //对象数组中存在该值
                that.updateQuery.other = that.updateQuery.StrBlackReason
              } else {
                //对象数组中不存在该值
                that.updateQuery.other = '其他'
              }
            }
          }
        }
      })
    },
    //下拉服务中心列表
    getServiceList() {
      xz.getsrarchinstAllList().then((res) => {
        // console.log("getServeList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const service = res[index];
          dataList.push({ StrSrvCent: service.Strinstname });
        }
        // console.log("getServeList", dataList);
        this.serviceList = dataList;
      });
    },
    //下拉立项部门
    getApartmentList(strsrvcent, strobjname) {
      xz.getsrarchinstobjinstlist(strsrvcent, strobjname).then((res) => {
        // console.log("getApartmentList", res);
        let dataList = [];
        for (let index = 0; index < res.length; index++) {
          const apartmentData = res[index];
          dataList.push({ StrObjInstName: apartmentData.StrObjInstName });
        }
        // console.log("getServeList", dataList);
        this.apartmentList = dataList;
      });
    },
    //筛选下拉
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    getBlackList() {
      this.listLoading = true;
      xz.getblackLists(this.listQuery).then((res) => {
        if (res.status == 'ok') {
          this.tableData = res.msg;
          this.totalcount = parseInt(res.totalcount);
        } else {
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btnBox{
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  background-color: #fff;
}
.ml20{
  margin-left: 20px;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
.input_width{
  width: 100%;
}
</style>


<style>
.black_dialog_box .dialog_box .el-select,
.black_dialog_box .dialog_box .el-input{
  width: 200px;
}
.black_dialog_box .input_width .el-form-item__content{
  width:calc(100% - 100px);
  box-sizing: border-box;
}
.p_roster_table.el-tabs--card {
  background-color: #fff;
}
.dropDownScreen .el-date-editor .el-range-separator {
  line-height: 24px;
}
.blacklistTable .el-table td {
  padding: 8px 0;
}
.blacklistTable .el-table th {
  padding: 10px 0;
}
.el-popper[x-placement^="bottom"] {
  margin-top: 5px;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.searchArea {
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  position: relative;
}
.searchArea .el-select .el-input {
  height: 30px;
  width: 130px;
  border-right: none;
}
.searchArea .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.input-with-select {
  width: 430px;
}
.searchArea .el-input__inner {
  height: 30px;
  line-height: 30px;
}
.searchArea .el-input__icon {
  line-height: 30px;
}
.direction .el-button {
  padding: 8px;
}
.dialog .el-dialog__header {
  padding: 0;
}
.formScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-top: 10px;
}
.formScreenInput .el-input__icon {
  margin-top: 10px;
  height: 32px;
  line-height: 32px;
}
.dialog .el-dialog__body {
  padding: 20px 20px 0 20px;
}
.formScreenInput .el-date-editor .el-range__icon {
  margin-top: 0;
}
</style>